import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/service/auth.service';

@Component({
  selector: 'app-logout',
  template: '',
})
export class LogoutComponent implements OnInit {
  constructor(private _auth: AuthService) {}

  ngOnInit(): void {
    this._auth.logout();
  }
}
